import type { Configuration } from '@gov-nx/api';
import { GovError } from '@gov-nx/core/app';
import { useConfigurationStore } from '@gov-nx/store';

export const useConfiguration = (): Configuration => {
	const configuration = useConfigurationStore('configuration');

	if (!configuration) {
		throw new GovError('[GOV] configuration not loaded yet');
	}

	return configuration;
};
